import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/rem'
import store from './stores/store'
import axios from 'axios'

import plugin from "./plugins/index"
import './plugins/extends' //引入扩展的vue方法
Vue.use(plugin, { router, axios })



// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()
// Vue.use(vConsole)

//引入预览组件
import VueImageSwipe from 'vue-image-swipe'
import 'vue-image-swipe/dist/vue-image-swipe.css'
Vue.use(VueImageSwipe)



import picker from 'COMPONENTS/base/picker/picker.vue' //选择地市
Vue.component(picker.name, picker);

import VueTouch from 'vue-touch';
Vue.use(VueTouch)

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false

// ios fast click
import FastClick from 'fastclick'
FastClick.attach(document.body);
FastClick.prototype.focus = function (targetElement) {
    var length;
    var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;
    var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;
    //兼容处理:在iOS7中，有一些元素（如date、datetime、month等）在setSelectionRange会出现TypeError
    //这是因为这些元素并没有selectionStart和selectionEnd的整型数字属性，所以一旦引用就会报错，因此排除这些属性才使用setSelectionRange方法
    if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month' && targetElement.type !== 'email') {
        length = targetElement.value.length;
        targetElement.setSelectionRange(length, length);//修复bug ios 11.3不弹出键盘，这里加上聚焦代码，让其强制聚焦弹出键盘
        targetElement.focus();
    } else {
        targetElement.focus();
    }
}

/**
 * platform=1 安卓 教师
 * platform=2 安卓 学生
 * platform=3 ios 教师
 * platform=4 ios 学生
 */

const search = searchToMap() // object map;
localStorage.setItem('search', JSON.stringify(search));
// if (location.search) {//存储手机信息，方便错误信息日志上报
//     localStorage.setItem('search', JSON.stringify(search));
// }
// 原生调vue 带tbkt_token  获取缓存本地
if (location.search && search.tbkt_token) {
    localStorage.setItem('Tbkt-Token', search.tbkt_token);
}

// 获取url 的值 返回数组形式
function searchToMap () {
    let search = location.search.slice(1);
    let _searchs = search.split('?');
    let map = {};
    _searchs.forEach(_s => {
        let _array = _s.split('&');
        _array.forEach(str => {
            let _str = str.split('=');
            map[_str[0]] = _str[1];
        });
    })
    return map;
}

//判断版本-留待以后使用
function judgeVersion (oldVer) {
    let ver = search.app_version;
    let verAry = ver.split('.');
    let oldVerAry = oldVer.split('.');
    for (let i in oldVerAry) {
        if (Number(verAry[i]) < Number(oldVerAry[i])) {
            return false;
        } else if (Number(verAry[i]) > Number(oldVerAry[i])) {
            return true;
        }
        if (i == oldVerAry.length - 1) {
            return true;
        }
    }
}

// vue 错误上报统计
// Vue.config.errorHandler = function (err, vm, info) {
//     let {
//         message, // 异常信息
//         name, // 异常名称
//         stack // 异常堆栈信息
//     } = err;
//     let url = location.href;
//     let { phone, user_id, user_type } = JSON.parse(localStorage.getItem('info')) || {};
//     let { mobile_version, app_version, mobile_model, mobile_name } = JSON.parse(localStorage.getItem('search')) || {};
//     let data = {
//         "cycle": info, //生命周期
//         "message": message,// 异常信息
//         "name": name,// 异常名称
//         "stack": stack,
//         "url": url, //当前url
//         "tbkt_token": localStorage.getItem("Tbkt-Token") || '', //用户的token
//         "phone": phone,	//用户手机号
//         "user_id": user_id,//用户id
//         "user_type": user_type,//用户身份 1学生 3教师,
//         "mobile_version": mobile_version || '',//手机版本
//         "app_version": app_version || '',//用户使用客户端版本
//         "mobile_model": mobile_model || '',//手机型号
//         "mobile_name": mobile_name || '',//手机型号名称
//     }
//     axios.post(DOMAIN_API_VUELOG_API_DJ_URLROOT + '/error/log', data).then((res) => { })
// }

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
